import styles from "../MoveOutChecklist.module.css";
import dayjs from "dayjs";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { InfoBox, PhaseBanner } from "./CommonComponents";
import { useEffect } from "react";

const schema = yup.object().shape({
    moveout_date: yup.date().required("This field is Required"),
    inspection_schedule_date: yup.date().required("This field is Required"),
    moveout_reason: yup.mixed().required("This field is Required"),
    moveout_notes: yup.string()
});



const MoveOutForm = ({ submitMoveoutChceckList, leaseData, propertyDetails, moveoutData }) => {
    const { handleSubmit, control, errors, watch, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            moveout_reason: "End of lease"
        }
    });

    useEffect(() => {
        console.log('moveoutData');
        console.log(moveoutData);

        if (moveoutData) {
            console.log('123456');
            setValue('moveout_date', dayjs(moveoutData?.moveout_date));
            setValue('inspection_schedule_date', dayjs(moveoutData?.inspection_schedule_date));
            setValue('moveout_reason', moveoutData?.moveout_reason);
            setValue('moveout_notes', moveoutData?.moveout_notes);
        }
    }, [moveoutData]);

    const onSubmit = (data) => {
        data = { ...data, current_step: 1, moveout_date: dayjs(data?.moveout_date).format('YYYY-MM-DD'), inspection_schedule_date: dayjs(data?.inspection_schedule_date).format('YYYY-MM-DD'), inspection_date: dayjs(data?.inspection_schedule_date).format('YYYY-MM-DD'), lease_date: (leaseData?.archived_leases?.length > 0) ? leaseData?.archived_leases[0]?.start_date : leaseData?.start_date, property_manager: propertyDetails?.property_manager, owner_name: propertyDetails?.owner_name, address: propertyDetails?.fulladdress }
        submitMoveoutChceckList(data);
    }

    const moveOutDate = watch('moveout_date');
    const inspectionScheduleDate = watch('inspection_schedule_date');
    const diffDays = dayjs(inspectionScheduleDate).diff(dayjs(moveOutDate), "day");
    const diffDays2 = dayjs().diff(dayjs(moveOutDate), "day");
    const pct = Math.min((diffDays2 / diffDays) * 100, 100);

    return (<div className={`${styles.tp} ${styles.tpActive}`}>
        <form className={`${styles.AddLayoutForm}`} onSubmit={handleSubmit(onSubmit)}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <PhaseBanner
                    type="blue"
                    icon="home-move"
                    title="Phase 1 — Flag the Move-Out"
                    sub="Record the move-out date and schedule the inspection. The checklist and final statement unlock only on or after inspection day."
                />

                <div className={styles.fg} style={{ marginBottom: 14 }}>
                    <div className={`${styles.fld} FormGroup`}>
                        <label className={styles.fl}>Move-out date <span style={{ color: "#EF4444" }}>*</span></label>
                        <Controller
                            name="moveout_date"
                            control={control}
                            render={(field) => (<DatePicker
                                {...field}
                                className={styles.fi}
                                value={field?.value ? field?.value : null}
                                onChange={(e) => {
                                    field.onChange(e);
                                }}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                    },
                                }}
                            />)}
                        />
                        <div className={styles.fieldHint}>Date tenant physically vacates</div>
                        {errors.moveout_date && (<p className={`${styles.ErrorM}`}>{errors.moveout_date.message}</p>)}
                    </div>
                    <div className={`${styles.fld} FormGroup`}>
                        <label className={styles.fl}>Inspection date <span style={{ color: "#EF4444" }}>*</span></label>
                        <Controller
                            name="inspection_schedule_date"
                            control={control}
                            render={(field) => (<DatePicker
                                {...field}
                                className={styles.fi}
                                value={field?.value ? field?.value : null}
                                onChange={(e) => {
                                    field.onChange(e);
                                }}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                    },
                                }}
                            />)}
                        />
                        <div className={styles.fieldHint}>Same day or later — when you physically inspect</div>
                        {errors.inspection_schedule_date && (<p className={`${styles.ErrorM}`}>{errors.inspection_schedule_date.message}</p>)}
                    </div>
                </div>


                {moveOutDate && inspectionScheduleDate && <>
                    {dayjs(inspectionScheduleDate).isBefore(dayjs(moveOutDate)) && <InfoBox type="red" icon="alert-circle">
                        Inspection date cannot be before the move-out date.
                    </InfoBox>}

                    {dayjs(inspectionScheduleDate).isSame(dayjs(moveOutDate), "day") && <div className={styles.diffVis}>
                        <div className={styles.diffVisTitle}>Date overview — Same day</div>
                        <div className={styles.diffTimeline}>
                            <div className={styles.diffEvent}>
                                <div className={`${styles.diffDot} ${styles.diffDotSame}`} />
                                <div className={`${styles.diffLabel} ${styles.diffLabelSame}`}>{dayjs(moveOutDate).format('MMM DD, YYYY')}</div>
                            </div>
                        </div>
                        <div className={styles.diffDaysLabel}>
                            Move-out and inspection on the same day. Checklist unlocks immediately after flagging.
                        </div>
                    </div>}

                    {dayjs(inspectionScheduleDate).isAfter(dayjs(moveOutDate)) && <div className={styles.diffVis}>
                        <div className={styles.diffVisTitle}>Date overview — {diffDays} day{diffDays > 1 ? "s" : ""} gap</div>
                        <div className={styles.diffTimeline}>
                            <div className={styles.diffEvent}>
                                <div className={`${styles.diffDot} ${styles.diffDotMo}`} />
                                <div className={`${styles.diffLabel} ${styles.diffLabelMo}`}>{dayjs(moveOutDate).format('MMM DD, YYYY')}</div>
                            </div>
                            <div className={styles.diffBar}>
                                <div className={styles.diffBarFill} style={{ width: pct + "%" }} />
                            </div>
                            <div className={styles.diffEvent}>
                                <div className={`${styles.diffDot} ${styles.diffDotIns}`} />
                                <div className={`${styles.diffLabel} ${styles.diffLabelIns}`}>{dayjs(inspectionScheduleDate).format('MMM DD, YYYY')}</div>
                            </div>
                        </div>
                        <div className={styles.diffDaysLabel} style={{ marginTop: 8 }}>
                            Tenant vacates <strong>{dayjs(moveOutDate).format('MMM DD, YYYY')}</strong>&nbsp;·&nbsp;Inspection{" "}
                            <strong>{dayjs(inspectionScheduleDate).format('MMM DD, YYYY')}</strong>&nbsp;·&nbsp;
                            <span style={{ color: "#D97706", fontWeight: 600 }}>
                                {diffDays} day{diffDays > 1 ? "s" : ""} between
                            </span>
                        </div>
                        <InfoBox type="amber" icon="lock" style={{ marginTop: 10, marginBottom: 0 }}>
                            Checklist and final statement are{" "}
                            <strong>locked until inspection day ({dayjs(inspectionScheduleDate).format('MMM DD, YYYY')})</strong>. You can flag now and return
                            on inspection day to complete.
                        </InfoBox>
                    </div>}
                </>}

                <div className={styles.fg} style={{ marginBottom: 14 }}>
                    <div className={`${styles.fld} FormGroup`}>
                        <label className={styles.fl}>Move-out reason</label>
                        <FormControl fullWidth>
                            <Controller
                                name="moveout_reason"
                                control={control}
                                render={(field) => (<Select
                                    {...field}
                                    onChange={(e) => {
                                        field.onChange(e);
                                    }}
                                >
                                    <MenuItem value={"End of lease"}>End of lease</MenuItem>
                                    <MenuItem value={"Early termination (tenant)"}>Early termination (tenant)</MenuItem>
                                    <MenuItem value={"Early termination (landlord)"}>Early termination (landlord)</MenuItem>
                                    <MenuItem value={"Eviction"} >Eviction</MenuItem>
                                </Select>)}
                            />
                        </FormControl>
                        {errors.moveout_reason && (<p className={`${styles.ErrorM}`}>{errors.moveout_reason.message}</p>)}
                    </div>
                </div>

                <div className={`${styles.fld} FormGroup`} style={{ marginBottom: 18 }}>
                    <label className={styles.fl}>Notes</label>
                    <Controller
                        name="moveout_notes"
                        control={control}
                        render={(field) => (<TextField
                            {...field}
                            className={styles.fi}
                            multiline
                            rows={4}
                            placeholder="Any special instructions..."
                        />)}
                    />
                </div>

                <div className={styles.fa}>
                    <span className={styles.faSpacer} />
                    <button className={`${styles.btn} ${styles.btnP}`} type="submit">
                        <i className="ti ti-flag" /> Flag move-out &amp; schedule inspection
                    </button>
                </div>
            </LocalizationProvider>
        </form >
    </div >);
};

export default MoveOutForm;
